import React, {Fragment, useRef} from "react";
import {connect} from "react-redux";

import LookCanvas from "../lookCanvas";
import WithZoomToFeature from "../hocs/withZoomToFeature";
import LookCanvasContext from "../lookCanvasContext";
import GroheSidebar from "./groheNavigation/groheSidebar";
import GroheCategories from "./groheNavigation/groheCategories/groheCategories";
import GroheFilters from "./groheNavigation/groheFilters/groheFilters";
import GroheSimilarProducts from "./groheNavigation/groheSimilarProducts";
// import GroheRoomIdeas from "./groheRoomIdeas/groheRoomIdeas";
import GroheFeatures from "./groheNavigation/groheFeatures/groheFeatures";
import GroheQuotingTool from "./groheNavigation/groheQuotingTool/groheQuotingTool";
import GroheFeatureInfo from "./groheNavigation/groheFeatureInfo";
import GroheMobileFooter from "./groheMobile/groheMobileFooter";
import GroheRoomLayouts from "./groheRoomLayouts/groheRoomLayouts";
import GroheSubCategories from "./groheNavigation/groheCategories/groheSubCategories";
import GroheTopButtons from "./groheTopButtons/groheTopButtons";
import GroheSameColorFeatures from "./groheNavigation/groheSameColorFeatures/groheSameColorFeatures";
import GroheSidebarHeader from "./groheNavigation/groheSidebarHeader";
import GroheCartRoutes from "./groheCart/groheCartRoutes";
import LookRouting from "../lookRouting";
import GroheWizard from "./groheNavigation/groheWizard/groheWizard";
import LookMainWizardSections from "../lookNavigation/lookMain/lookMainWizardSections";
import ShopPage from "../shop/shopPage";
import GroheCompatabilitySection from "./groheNavigation/groheCompatabilitySection";
import LookNotInVisualizerPopper from "../lookNavigation/lookNotInVisualizerPopper";

const GroheComponents = (props) => {

  const {allowRouting, lookOpened, isMobile} = props;
  const imageCanvas = useRef();

  return (
    <div className="wrapper">
      <LookCanvasContext.Provider value={imageCanvas}>
        <WithZoomToFeature imageCanvas={imageCanvas}>
          {(zoomToFeatureGroup) => <LookCanvas imageCanvas={imageCanvas} zoomToFeatureGroup={zoomToFeatureGroup} />}
        </WithZoomToFeature>
        <LookNotInVisualizerPopper/>
        <GroheTopButtons imageCanvas={imageCanvas}/>
        {isMobile ? (
          <GroheMobileFooter/>
        ) : null}
        <GroheSidebarHeader/>
        <GroheSidebar imageCanvas={imageCanvas}/>
        <GroheFeatures/>
        {document.kvConfig.visualizerType === "bvLook" ? <GroheSameColorFeatures/> : null}
        <ShopPage/>
        <GroheCartRoutes/>
        <GroheCategories/>
        <GroheRoomLayouts/>
        <LookMainWizardSections/>
        {lookOpened ? (
          <Fragment>
            <GroheQuotingTool/>
            {/*<GroheRoomIdeas/>*/}
            <GroheSubCategories/>
            <GroheFilters/>
            <GroheSimilarProducts/>
            <GroheFeatureInfo/>
          </Fragment>
        ) : null}
        <GroheWizard/>
        <GroheCompatabilitySection/>
        {allowRouting ? (
          <WithZoomToFeature imageCanvas={imageCanvas}>
            {(zoomToFeatureGroup) => <LookRouting imageCanvas={imageCanvas} zoomToFeatureGroup={zoomToFeatureGroup} />}
          </WithZoomToFeature>
        ) : null}
      </LookCanvasContext.Provider>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookOpened} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    lookOpened,
    isMobile,
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheComponents);
